import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import langIsEn from '../../utils/langIsEn';
import VisibilitySensor from 'react-visibility-sensor';
import styles from './ContentPic.css';

class ContentPic extends Component {
  static propTypes = {
    pic: PropTypes.object.isRequired,
    url: PropTypes.string.isRequired,
  };

  state = {
    isVisible: false,
  }

  onChange(isVisible) {
    if (!this.state.isVisible && isVisible) {
      this.setState({
        isVisible: isVisible,
      });
    }
  }

  render() {
    const { pic, url } = this.props;
    const { engTitle, chtTitle, engContent, chtContent } = pic;
    const { isVisible } = this.state;

    let title = null, content = null;
    if (langIsEn()) {
      title = engTitle;
      content = engContent;
    } else {
      title = chtTitle;
      content = chtContent;
    }

    return (
      <div className={styles.contentPic}>
        {(title || content) &&
          <div className={classnames(
            styles.detailBlock,
            { [styles.chtDetailBlock]: !langIsEn() }
          )}>
            {title && <p className={styles.title}>{title}</p>}
            {content && <p className={styles.content}>{content}</p>}
          </div>
        }
        <div className={styles.img}>
          <VisibilitySensor
            onChange={this.onChange.bind(this)}
            partialVisibility={true}
          >
            <img
              className={classnames(styles.content, { 'animated fadeInUp': isVisible })}
              src={url}
              alt={pic.engTitle}
            />
          </VisibilitySensor>
        </div>
      </div>
    );
  }
}

export default ContentPic;



// WEBPACK FOOTER //
// ./src/components/content-pic/ContentPic.js